module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "confirm-layout"
  }, [_c('div', {
    staticClass: "alert alert-success"
  }, [_c('span', [_vm._v("管制組藥退藥（" + _vm._s(_vm.currentMed.parent_medication.generic_name) + "）")])]), (_vm.stage === 'selectReason') ? _c('ConfirmReason', {
    on: {
      "setReason": _vm.getReason
    }
  }) : _vm._e(), (_vm.stage === 'confirm') ? _c('div', {
    staticClass: "confirm-form"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("選擇使用情形 (" + _vm._s(_vm.setIndex + 1) + "/" + _vm._s(this.controlMedSet.length) + ")")]), _c('div', {
    staticClass: "button-wrap",
    on: {
      "click": function($event) {
        return _vm.setReturnStatus('RECYCLE_EMPTY')
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button"
  }, [_vm._v("已使用（退空瓶）")])]), _c('div', {
    staticClass: "button-wrap",
    on: {
      "click": function($event) {
        return _vm.setReturnStatus('RETURN')
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-lg confirm-button"
  }, [_vm._v("未使用（退藥）")])])]) : _vm._e(), (_vm.stage === 'action') ? _c('Action', {
    attrs: {
      "inputReadOnly": true,
      "defaultNum": _vm.forAction.defaultNum,
      "deviceId": _vm.forAction.deviceId,
      "checkNum": _vm.forAction.checkNum,
      "defaultPackCount": 0,
      "limitPackCount": false
    },
    on: {
      "setActionData": _vm.getThisAmount
    }
  }, [_c('h5', [_c('strong', [_c('span', [_vm._v("退回管制組藥")])])])]) : _vm._e(), (_vm.stage === 'finish') ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f3a2620","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReturnDrugFlow/ReturnEmptyBottle.vue
// module id = 1473
// module chunks = 1